import { MobilityConceptLogo } from "@App/Components/atoms/whitelabel/logos/MobilityConceptLogo";
import { RepareoLogo } from "@App/Components/atoms/whitelabel/logos/RepareoLogo";
import type { Config } from "@App/configs/interfaces";
import { config as defaultConfig } from "@App/configs/default";
import { differenceInBusinessDays } from "date-fns";
import { ServiceIsVehicleReturn } from "@App/utils/conditionals/services";

/**
 * Configuration for the MFS Mara whitelabel.
 * Extends the default configuration with specific settings for MFS Mara.
 */
export const config: Partial<Config> = {
  slug: "mara",
  navbar: {
    logos: {
      right: {
        component: <MobilityConceptLogo />,
      },
      left: {
        component: <RepareoLogo />,
      },
    },
    backToPartnerButton: {
      url: "https://www.mobility-concept.de/",
    },
  },
  garageList: {
    // merge with default
    ...defaultConfig.garageList,
    disableFetchLocationOnLoad: true,
  },
  reviews: {
    show: true,
  },
  dayPicker: {
    isExtraCostDay: (date, contractEnd) => {
      const workingDaysDiff = differenceInBusinessDays(contractEnd, date);
      return workingDaysDiff > 5;
    },
    showExtraCostDayInLegend: (service) => ServiceIsVehicleReturn(service),
  },
};

export default config;
